module.exports = __webpack_public_path__ + "img/Proliferation-NPC_GSE200310.65be2da5.png";